<template>
  <div class="d-flex">
    <template v-if="bed">
      <bed-property-icon-item :label="bed"></bed-property-icon-item>
      <vertical-separator gap="12px"></vertical-separator>
    </template>
    <template v-if="bath">
      <bath-property-icon-item :label="bath"></bath-property-icon-item>
      <vertical-separator gap="12px"></vertical-separator>
    </template>
    <template v-if="parking">
      <parking-property-icon-item :label="parking"></parking-property-icon-item>
    </template>
  </div>
</template>

<script>
import BedPropertyIconItem from './BedPropertyIconItem.vue';
import BathPropertyIconItem from './BathPropertyIconItem.vue';
import ParkingPropertyIconItem from './ParkingPropertyIconItem.vue';
import VerticalSeparator from '../Common/VerticalSeparator.vue';

export default {
  props: {
    bed: [String, Number],
    bath: [String, Number],
    parking: [String, Number],
  },
  components: {
    BedPropertyIconItem,
    BathPropertyIconItem,
    ParkingPropertyIconItem,
    VerticalSeparator,
  },
};
</script>
